/**
 * UI KIT
 * https://www.figma.com/design/MPOKZpSEmk2l4uZ0SeOLj1/Ui-Kit-2.0-(2024)?node-id=269-20636&t=HetWzzVCMW3LZoVv-1
 */
import React from "react";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { Root } from "./Container.styled";

interface Props {
  testId?: string;
}

export const Container: React.FC<React.PropsWithChildren<Props>> = props => {
  return (
    <TestWrapper testId={props.testId}>
      <Root>{props.children}</Root>
    </TestWrapper>
  );
};
